const Theme = {
    body_background_color: '#5CAB32',

    logo_image_url: 'bioparc.png',
    logo_height: 110,

    button_color: '#5CAB32',
    // button_font: '',
    button_text_uppercase: true,
    // button_radius: 0,
    button_no_border: false,

    button_half_border_color: '#5CAB32',

    // text_font: `'Poppins', sans-serif`,

    title_font: `'Poppins', sans-serif`,
    title_weight: 600,

    subtitle_font: `'Poppins', sans-serif`,
    subtitle_weight: 600,
  }

  export default Theme
